import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Col, Row } from 'antd';

import MyTaskKanbanStatusColumn from '@totem/components/ticketing/myTickets/myTasks/myTaskKanbanStatusColumn';

const MyTaskKanbanBoard = () => {
  return (
    <DndProvider backend={HTML5Backend}>
      <Row gutter={[16, 16]}>
        <Col span={5}>
          <MyTaskKanbanStatusColumn status={'PENDING'} color={'#bf00ff'} />
          <MyTaskKanbanStatusColumn status={'REOPENED'} color={'#F33A6A'} />
          <MyTaskKanbanStatusColumn status={'BLOCKED'} color={'#D22B2B'} />
        </Col>
        <Col span={5}>
          <MyTaskKanbanStatusColumn status={'SCHEDULED'} color={'#00FFFF'} />
          <MyTaskKanbanStatusColumn status={'WAITING'} color={'#FFA500'} />
          <MyTaskKanbanStatusColumn status={'ON HOLD'} color={'#FF5F1F'} />
        </Col>
        <Col span={5}>
          <MyTaskKanbanStatusColumn status={'IN PROGRESS'} color={'#00bfff'} />
        </Col>
        <Col span={5}>
          <MyTaskKanbanStatusColumn status={'REVIEW'} color={'#FFC000'} />
          <MyTaskKanbanStatusColumn status={'APPROVED'} color={'#228B22'} />
          <MyTaskKanbanStatusColumn status={'REJECTED'} color={'#B80F0A'} />
        </Col>
        <Col span={4}>
          <MyTaskKanbanStatusColumn status={'COMPLETED'} color={'#228B22'} />
          <MyTaskKanbanStatusColumn status={'CANCELED'} color={'#71797E'} />
          <div>(Completed & Cancelled Task Not Shown)</div>
        </Col>
      </Row>
    </DndProvider>
  );
};

export default MyTaskKanbanBoard;
